import { render, staticRenderFns } from "./BaseTableKTCForever.vue?vue&type=template&id=06463275&scoped=true&"
import script from "./BaseTableKTCForever.vue?vue&type=script&lang=js&"
export * from "./BaseTableKTCForever.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableKTCForever.vue?vue&type=style&index=0&id=06463275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06463275",
  null
  
)

export default component.exports